// extracted by mini-css-extract-plugin
export var sliderRange = "_pt-2";
export var sliderRoot = "_pt-0";
export var sliderThumb = "_pt-3";
export var sliderTrack = "_pt-1";